interface IRoutes {
  [key: string]: {
    title: string;
    url: string;
    isRoleBasedRoute: boolean;
    isSubRoute: boolean;
    path?: string;
  };
}
export const ROUTES: IRoutes = {
  accessDenied: {
    title: "AccessDenied",
    url: "/access-denied",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  home: {
    title: "Home",
    url: "/home",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventory: {
    title: "LabInventory",
    url: "/lab-inventory",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryAdd: {
    title: "AddLabInventory",
    url: "/lab-inventory/ECAASInfo/Create",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  labInventoryEdit: {
    title: "EditLabInventory",
    url: "/lab-inventory/ECAASInfo/Edit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  labInventoryDelete: {
    title: "DeleteLabInventory",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  labInventoryRestore: {
    title: "RestoreLabInventory",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  labInventoryProject: {
    title: "LabInventoryProject",
    url: "/admin/lab-inventory-project/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryProjectAdd: {
    title: "AddLabInventoryProject",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryProjectEdit: {
    title: "EditLabInventoryProject",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryProjectDelete: {
    title: "DeleteLabInventoryProject",
    url: "",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  hwReport: {
    title: "hwReport",
    url: "/tools/hw-report/",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  execWcscli: {
    title: "exec",
    url: "/tools/exec-wcscli/",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  checkoutSummary: {
    title: "CheckOutSummary",
    url: "/lab-inventory/CheckOutSummary",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryDetails: {
    title: "details",
    url: "/lab-inventory/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  powerBI: {
    title: "PowerBI",
    url: "/power-bi",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  leaseHistory: {
    title: "leaseHistory",
    url: "/lab-inventory/lease-history",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  leaseInactive: {
    title: "leaseInactive",
    url: "/lab-inventory/lease-inactive",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryReport: {
    title: "LabInventoryReport",
    url: "/power-bi/lab-inventory",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  baasRaasReport: {
    title: "BaaSRaaSReport",
    url: "/power-bi/baas-raas",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryAudit: {
    title: "LabInventoryAudit",
    url: "/audit/lab-inventory-info-audit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
   labInventoryLeaseAudit: {
    title: "LabInventoryLeaseAudit",
    url: "/audit/lab-inventory-lease-audit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  rackAudit: {
    title: "RackAudit",
    url: "/audit/rackAudit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  importLabInventoryInfo: {
    title: "ImportLabInventoryInfo",
    url: "/admin/import-lab-inventory-info",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  importRack: {
    title: "ImportRack",
    url: "/admin/import-rack",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  importSwitch: {
    title: "ImportSwitch",
    url: "/admin/import-switch",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryCategory: {
    title: "LabInventoryCategory",
    url: "/admin/lab-inventory-category/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryCategoryAdd: {
    title: "AddLabInventoryCategory",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryCategoryEdit: {
    title: "EditLabInventoryCategory",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryCategoryDelete: {
    title: "DeleteLabInventoryCategory",
    url: "",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryType: {
    title: "LabInventoryType",
    url: "/admin/lab-inventory-type/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryTypeAdd: {
    title: "AddLabInventoryType",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryTypeEdit: {
    title: "EditLabInventoryType",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryTypeDelete: {
    title: "DeleteLabInventoryType",
    url: "",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryBundle: {
    title: "LabInventoryBundle",
    url: "/admin/lab-inventory-bundle/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryBundleAdd: {
    title: "AddLabInventoryBundle",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryBundleEdit: {
    title: "EditLabInventoryBundle",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  labInventoryBundleDelete: {
    title: "DeleteLabInventoryBundle",
    url: "",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  powerLimit: {
    title: "Powerlimit",
    url: "/admin/powerlimit/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  powerLimitAdd: {
    title: "AddPowerlimit",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  powerLimitEdit: {
    title: "EditPowerlimit",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  powerLimitDelete: {
    title: "DeletePowerlimit",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  site: {
    title: "Site",
    url: "/admin/site/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  siteAdd: {
    title: "AddSite",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  siteEdit: {
    title: "EditSite",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  siteDelete: {
    title: "DeleteSite",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  building: {
    title: "Building",
    url: "/admin/building/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  buildingAdd: {
    title: "AddBuilding",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  buildingEdit: {
    title: "EditBuilding",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  buildingDelete: {
    title: "DeleteBuilding",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  manufacturerName: {
    title: "ManufacturerName",
    url: "/admin/manufacturerName/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  manufacturerNameAdd: {
    title: "AddManufacturerName",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  manufacturerNameEdit: {
    title: "EditManufacturerName",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  manufacturerNameDelete: {
    title: "DeleteManufacturerName",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  benchNumber: {
    title: "BenchNumber",
    url: "/Dropdown/benchNumber",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labNumber: {
    title: "LabNumber",
    url: "/Dropdown/labNumber",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  securityGroup: {
    title: "SecurityGroup",
    url: "/admin/security-groups/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  securityGroupAdd: {
    title: "AddSecurityGroup",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  securityGroupEdit: {
    title: "EditSecurityGroup",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  securityGroupDelete: {
    title: "DeleteSecurityGroup",
    url: "delete",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  userActivity: {
    title: "UserActivity",
    url: "/admin/user-activity",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryStatus: {
    title: "LabInventoryStatus",
    url: "/admin/inventory-status/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  labInventoryStatusAdd: {
    title: "AddLabInventoryStatus",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  labInventoryStatusEdit: {
    title: "EditInventoryStatus",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  labInventoryStatusDelete: {
    title: "DeleteInventoryStatus",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  serviceContract: {
    title: "ServiceContract",
    url: "/admin/service-contract",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  serviceContractAdd: {
    title: "AddServiceContract",
    url: "/admin/service-contract/create",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  serviceContractEdit: {
    title: "EditServiceContract",
    url: "/admin/service-contract/edit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  serviceContractDelete: {
    title: "DeleteServiceContract",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  sWLicensePackage: {
    title: "SWLicensesPackages",
    url: "/admin/sw-licenses-packages/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  sWLicensePackageAdd: {
    title: "AddSWLicensePackage",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  sWLicensePackageEdit: {
    title: "EditSWLicensePackage",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  sWLicensePackageDelete: {
    title: "DeleteSWLicensePackage",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  blade: {
    title: "Blade",
    url: "/lab-hw/blade/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  bladeDetails: {
    title: "Blade Details",
    url: "/lab-hw/blade/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  notesAdd: {
    title: "Add Notes",
    url: "add/notes",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  rackNotesAdd: {
    title: "Add Notes",
    url: "/lab-hw/rack/details/rackNotesAdd",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  notesEdit: {
    title: "Update Notes",
    url: "edit/notes",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  chassisManager: {
    title: "ChassisManager",
    url: "/lab-hw/chassis-manager/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  chassisManagerAdd: {
    title: "AddChassisManager",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  chassisManagerEdit: {
    title: "EditChassisManager",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  chassisManagerDelete: {
    title: "DeleteChassisManager",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  corsica: {
    title: "Corsica",
    url: "/machines/corsica/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  corsicaAdd: {
    title: "AddCorsica",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  corsicaEdit: {
    title: "EditCorsica",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  infraDevice: {
    title: "InfraDevice",
    url: "/lab-hw/infra-device",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  infraDeviceAdd: {
    title: "AddInfraDevice",
    url: "/lab-hw/infra-device/create",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  infraDeviceEdit: {
    title: "EditInfraDevice",
    url: "/lab-hw/infra-device/edit",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  infraDeviceDelete: {
    title: "DeleteInfraDevice",
    url: "delete",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  infraDeviceDetails: {
    title: "InfraDeviceDetails",
    url: "/lab-hw/infra-device/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  ipAddressManagement: {
    title: "IpAddressManagement",
    url: "/lab-hw/infra-device/ipaddressmanagement",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  jbod: {
    title: "JBOD/JBOF",
    url: "/lab-hw/jbod/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  jbodDetail: {
    title: "DetailJbod",
    url: "detail",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  jbodLog: {
    title: "LogJbod",
    url: "/lab-hw/jbod/log",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  pdu: {
    title: "PDU",
    url: "/lab-hw/pdu/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  pduAdd: {
    title: "AddPdu",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  pduEdit: {
    title: "EditPdu",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  pduDelete: {
    title: "DeletePdu",
    url: "delete",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  power: {
    title: "Power",
    url: "/lab-hw/power/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  powerDetails: {
    title: "Power",
    url: "/lab-hw/power/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  rack: {
    title: "Rack",
    url: "/lab-hw/rack/*",
    path: "/lab-hw/rack",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  rackAdd: {
    title: "AddRack",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  rackEdit: {
    title: "EditRack",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  rackDetails: {
    title: "details",
    url: "/lab-hw/rack/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  powerThermal: {
    title: "powerThermal",
    url: "/lab-hw/rack/power-thermal",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  rackManager: {
    title: "RackManager",
    url: "/lab-hw/rack-manager/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  rackManagerAdd: {
    title: "AddRackManager",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  rackManagerEdit: {
    title: "EditRackManager",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  rackManagerDelete: {
    title: "DeleteRackManager",
    url: "",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  datacenter: {
    title: "Datacenter",
    url: "/datacenter/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  datacenterAdd: {
    title: "AddDatacenter",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  datacenterEdit: {
    title: "EditDatacenter",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  datacenterView: {
    title: "ViewDatacenter",
    url: "view",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  datacenterExport: {
    title: "ExportDatacenter",
    url: "export",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  datacenterdetails: {
    title: "DatacenterDetails",
    url: "/datacenter-details/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  dimms: {
    title: "Dimms",
    url: "/blade-hw/dimms",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  dimmsDetails: {
    title: "Dimms Details",
    url: "/blade-hw/dimms/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  disks: {
    title: "Disks",
    url: "/blade-hw/disks",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  disksDetails: {
    title: "Disk Details",
    url: "/blade-hw/disks/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  nics: {
    title: "Nics",
    url: "/blade-hw/nics",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  nicsDetails: {
    title: "Nics Details",
    url: "/blade-hw/nics/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  procs: {
    title: "Procs",
    url: "/blade-hw/procs",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  procsDetails: {
    title: "Proc Details",
    url: "/blade-hw/procs/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  fpgas: {
    title: "FPGAs",
    url: "/blade-hw/fpgas",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  fpgasDetails: {
    title: "FPGA Details",
    url: "/blade-hw/fpgas/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  tpms: {
    title: "TPMs",
    url: "/blade-hw/tpms",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  tpmsDetails: {
    title: "TPMs Details",
    url: "/blade-hw/tpms/details",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  baasRaasReservationRequests: {
    title: "baasRaasReservationRequests",
    url: "/baas-raas/reservation-requests",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  baasRaasReservationRequestAdd: {
    title: "BAASRAASReservationRequestAdd",
    url: "/baas-raas/reservation-requests/create",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  baasRaasReservationRequestClose: {
    title: "BAASRAASReservationRequestClose",
    url: "close",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  baasRaasLeaseManagement: {
    title: "BAAS & RAAS Lease Management",
    url: "/baas-raas/lease-management/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  baasRaasBenchReservation: {
    title: "BaasRaasBenchReservation",
    url: "/baas-raas/lease-management/bench-reservation",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  baasRaasCheckOut: {
    title: "BAASRAASCheckOut",
    url: "checkout",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  baasRaasValidate: {
    title: "BAASRAASValidate",
    url: "validate",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  baasRaasCheckInExtend: {
    title: "BAASRAASCheckInExtend",
    url: "checkin-extend",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  baasRaasCheckInExtendInSG: {
    title: "BAASRAASCheckInExtendInSG",
    url: "checkin-extend-in-sg",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  baasRaasTransfer: {
    title: "BAASRAASTransfer",
    url: "transfer",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  allleases: {
    title: "AllLeases",
    url: "/machines/allleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  CheckIn: {
    title: "CheckIn",
    url: "/machines/allleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  Extend: {
    title: "Extend",
    url: "/machines/allleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  CutPower: {
    title: "CutPower",
    url: "/machines/allleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  RestorePower: {
    title: "RestorePower",
    url: "/machines/allleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  myleases: {
    title: "MyLeases",
    url: "/machines/myleases",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
  loglist: {
    title: "Log List",
    url: "/lab-hw/blade/details/loglist",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  sustaining: {
    title: "Sustaining",
    url: "/machines/sustaining/*",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  sustainingAdd: {
    title: "SustainingAdd",
    url: "add",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  sustainingEdit: {
    title: "SustainingEdit",
    url: "edit",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  sustainingCheckIn: {
    title: "SustainingCheckIn",
    url: "checkin",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  sustainingCheckout: {
    title: "SustainingCheckout",
    url: "checkout",
    isRoleBasedRoute: true,
    isSubRoute: true,
  },
  hwskuAdd: {
    title: "hwskuAdd",
    url: "add",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  hwskuEdit: {
    title: "hwskuEdit",
    url: "edit",
    isRoleBasedRoute: false,
    isSubRoute: true,
  },
  powerinfo: {
    title: "Power Information",
    url: "/lab-hw/blade/details/powerinfo",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  temperatureinfo: {
    title: "Temperature Information",
    url: "/lab-hw/blade/details/temperatureinfo",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  currentpower: {
    title: "Power Information",
    url: "/lab-hw/blade/details/currentpower",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },
  currenttemperature: {
    title: "Temperature Information",
    url: "/lab-hw/blade/details/currenttemperature",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },

  notesHistory: {
    title: "Notes History",
    url: "/lab-hw/rack/details/notesHistory",
    isRoleBasedRoute: false,
    isSubRoute: false,
  },

  user: {
    title: "User",
    url: "/admin/user/*",
    isRoleBasedRoute: true,
    isSubRoute: false,
  },
};
